import { Injectable } from '@angular/core';
import { persistState, PersistStateSelectFn, Store, StoreConfig } from '@datorama/akita';
import { UserStoreModel } from '../models/user.model';

const USER_STORE_NAME = 'user';
const persistUserStateProps: PersistStateSelectFn<UserStoreModel> = ({ app_theme, timezone, locale }) => ({
  // UserEnvironmentService props
  app_theme,
  timezone,
  locale,
});
persistUserStateProps.storeName = USER_STORE_NAME;

export const authStoragePersistState = persistState({
  storage: localStorage,
  key: 'user-storage',
  include: [USER_STORE_NAME],
  select: [persistUserStateProps],
});

const initialUserState: Partial<UserStoreModel> = {};

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: USER_STORE_NAME })
export class UserStore extends Store<UserStoreModel> {
  constructor() {
    super(initialUserState);
  }

  updateUser(user: Partial<UserStoreModel>) {
    this.update((state) => ({
      ...state,
      ...user,
    }));
  }

  setUser(user: UserStoreModel) {
    this.update(user);
  }
}
